import styles from "./WizardHeader.module.scss";
import React from "react";

const WizardHeaderTitle = ({children}) => {
    return <div className={styles.title}>
        {children}
    </div>
};

export default WizardHeaderTitle;
